<p-menu #menu [model]="items" [popup]="true"></p-menu>
@if (items.length > 0) {

<div
  (click)="toggle($event)"
  class="cursor-pointer inline w-full md:w-auto"
  data-testid="dropdown-trigger"
  tabindex="0"
  role="button"
>
  <ng-content></ng-content>
</div>
}
